/**
 * 朋际品牌资源路径（源自仓库根目录 icon.png，构建时同步至 public/）
 * 禁止在业务页硬编码 logo URL。
 */
const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export const BRAND_ASSETS = {
  icon: `${publicBase}/icon.png`,
  logo192: `${publicBase}/logo192.png`,
  logo512: `${publicBase}/logo512.png`,
  appleTouch: `${publicBase}/apple-touch-icon.png`,
  favicon: `${publicBase}/favicon.ico`,
};

export const BRAND_NAME = '朋际';
export const BRAND_ALT = '朋际标志';
